import en from './en';
import cn from './cn';
import ja from './ja';
import ko from './ko';
import ru from './ru';
import es from './es';
import fr from './fr';
import de from './de';
import pt from './pt';
import it from './it';
import tr from './tr';
import vi from './vi';
import id from './id';
import hi from './hi';
import ar from './ar';
import th from './th';
import tw from './tw';
import fa from './fa';
export default {
    en: en,
    cn: cn,
    ja: ja,
    ko: ko,
    ru: ru,
    es: es,
    fr: fr,
    de: de,
    pt: pt,
    it: it,
    tr: tr,
    vi: vi,
    id: id,
    hi: hi,
    ar: ar,
    th: th,
    tw: tw,
    fa: fa,
}